import { Competition } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useDaily(region?: string, date?: Date) : [Competition[], () => void] {
    const [daily, onLoadMoreDaily] = useBatchedQuery({ region: region, queryType: 'discoverDaily', date });
    return [daily, onLoadMoreDaily];
}
